import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { NotificationsCenter, useNotificationsFeed } from './notifications'

/**
 * Square Code V2 Notifications — route wrapper (PHASE_2M P4).
 *
 * Registered at /square/command-center/notifications (AccessGate).
 * "Scheduled" became Notifications: a REAL aggregation over the live comms /
 * tasks / Daily-calls / daily-meetings backends. The wrapper owns the live
 * feed hook; the surface is presentational.
 */
export default function SquareCodeNotificationsRoute() {
  const navigate = useNavigate()
  const { feed, reload, markMessagesRead, markState, markableChannels } = useNotificationsFeed()
  return (
    <NotificationsCenter
      feed={feed}
      onOpen={(to) => navigate(to)}
      onReload={reload}
      onMarkMessagesRead={() => void markMessagesRead()}
      markState={markState}
      markableChannels={markableChannels}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
      onBackCommandCenter={() => navigate(COMMAND_CENTER_ROOT)}
    />
  )
}
